export type ILanguageOptionsAvailable = "pt" | "en" | "es";

export const languagesAvailable: ILanguageOptionsAvailable[] = ["pt", "en", "es"];

interface ITranslationContextProps{
    changeLanguage: (lng: ILanguageOptionsAvailable) => void;
    translate: (text: string, objKeys?: object) => string;
    currentLanguage: ILanguageOptionsAvailable;
}

export default ITranslationContextProps;

